"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.METHOD = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var METHOD = {
  POST: 'post',
  GET: 'get'
};
exports.METHOD = METHOD;

var SimpleForm = function SimpleForm(_ref) {
  var wrapperClass = _ref.wrapperClass,
      method = _ref.method,
      onSubmit = _ref.onSubmit,
      children = _ref.children;

  var handleSubmit = function handleSubmit(evt) {
    evt.preventDefault();

    if (onSubmit) {
      onSubmit();
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
    className: wrapperClass,
    method: method,
    onSubmit: handleSubmit,
    encType: "multipart/form-data",
    children: children
  });
};

SimpleForm.propTypes = {
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  wrapperClass: _propTypes["default"].string,

  /**
   * {
   *  "info": "Cumplimenta la propiedad method del DOM para este elemento: post o get",
   *  "kind": "playground",
   *  "beautifulName": "Tipo"
   * }
   */
  method: _propTypes["default"].oneOf(['post', 'get']),

  /**
   * {
   *  "info": "Función js que se ejecutará al hacer click en el botón del formulario",
   *  "kind": "playground",
   *  "beautifulName": "Funcion"
   * }
   */
  onSubmit: _propTypes["default"].func,

  /**
   * {
   *  "info": "Array de elementos que forman el componente",
   *  "kind": "playground",
   *  "beautifulName": "Elementos del formulario"
   * }
   */
  children: _propTypes["default"].node.isRequired
};
SimpleForm.defaultProps = {
  wrapperClass: '',
  method: METHOD.GET,
  onSubmit: null
};
var _default = SimpleForm;
exports["default"] = _default;

//# sourceMappingURL=index.js.map